export const History = Symbol.for('history');
